import React from "react";
import FormRow from "../../components/formrow";
import { type GetSetValueProp, type Theme } from "../models";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";

const options: Array<{ text: string, value: Theme }> = [{
  text: RESX.EmbedWizard.Light,
  value: "normal"
}, {
  text: RESX.EmbedWizard.Dark,
  value: "dark"
}];

const ThemeDropdown = (props: GetSetValueProp<Theme>) => {
  const selectedValue = options.find(o => o.value === props.value);

  return <FormRow label={RESX.EmbedWizard.Theme}>
    <BaseReactSelectDropdown
      options={options}
      value={selectedValue}
      onChange={v => { props.setValue(v.value); }}
      config={{}}
      getLabel={o => o.text}
      getValue={o => o.value}
      excludeKeys={[]}
    />
  </FormRow>;
};

export default ThemeDropdown;